export default "__VITE_ASSET__CjjtLvCJ__"